import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '..';

const UserListTable = ({jobsData}) => {
      const history = useNavigate()
  const handleDelete = async(id)=>{
    
    let headersList = {
      "Accept": "*/*",
      "Content-Type": "application/json"
     }
     let response = await fetch(API_URL+`/api/user/delete/${id}`, { 
       method: "DELETE",
       headers: headersList
     });
     let data = await response.json();
     if(data.message=="User deleted successfully"){
        window.location.reload();
     }
  
   
  }
    useEffect(() => {
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'name' },
            { data: 'email' },
            { data: 'status' },
            { data: 'role' },
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
               
                <button class="btn btn-primary edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i></button>
                <button class="btn btn-danger delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i></button>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/edit-user/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Users</h5>
            <div className="col-md-6  text-end" >
              <Link to={'/create-user'} className='btn btn-info text-end'>Add New</Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">

                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Full Name</th>
                <th scope="col">Email</th>
                <th scope="col">Status</th>
                <th scope="col">Role</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default UserListTable